/**
 * @file
 * Router Configuration
 * Used in library: vue-router
 *
 * Use this file to register the App routes
 * See https://router.vuejs.org/guide/#javascript
 * This configuration will be set in @/bootstrap/app.ts
 */

import {RouterOptions} from 'vue-router'

import DefaultLayout from '@/views/layouts/DefaultLayout.vue'
import DashboardView from '@/views/DashboardView.vue'

import SignInView from '@/views/auth/SignInView.vue'
import RecoverPasswordByMailView from '@/views/auth/RecoverPasswordByMailView.vue'
import ResetPasswordView from '@/views/auth/ResetPasswordView.vue'

import ListAlertaCargaView from '@/views/list/ListAlertaCargaView.vue'
import ListPromocaoView from '@/views/list/ListPromocaoView.vue'
import ListResponsavelWebhookView from '@/views/list/ListResponsavelWebhookView.vue'
import ListConfigAlertaView from '@/views/list/ListConfigAlertaView.vue'
import ListCargaMedlogView from '@/views/list/ListCargaMedlogView.vue'
import ListWebserviceIntegracaoView from '@/views/list/ListWebserviceIntegracaoView.vue'
import ListTypeWebhookView from '@/views/list/ListTypeWebhookView.vue'
import ListStatusCargaView from '@/views/list/ListStatusCargaView.vue'
import ListResponsavelVisualizadorView from '@/views/list/ListResponsavelVisualizadorView.vue'
import ListCargaPesquisaSatisfacaoView from '@/views/list/ListCargaPesquisaSatisfacaoView.vue'
import ListAuditoriaTransfolhaView from '@/views/list/ListAuditoriaTransfolhaView.vue'
import ListCargaSaraivaView from '@/views/list/ListCargaSaraivaView.vue'
import ListTipoRelatorioView from '@/views/list/ListTipoRelatorioView.vue'
import ListAdministradorView from '@/views/list/ListAdministradorView.vue'
import ListOcorrenciaTrackingView from '@/views/list/ListOcorrenciaTrackingView.vue'
import ListResponsavelAssociadoView from '@/views/list/ListResponsavelAssociadoView.vue'
import ListTipoPessoaRecebedorView from '@/views/list/ListTipoPessoaRecebedorView.vue'
import ListRequestSswView from '@/views/list/ListRequestSswView.vue'
import ListResponsavelConfigSmsView from '@/views/list/ListResponsavelConfigSmsView.vue'
import ListCargaAryztaView from '@/views/list/ListCargaAryztaView.vue'
import ListTokenPushView from '@/views/list/ListTokenPushView.vue'
import ListCargaCorreiosView from '@/views/list/ListCargaCorreiosView.vue'
import ListCargaFotoView from '@/views/list/ListCargaFotoView.vue'
import ListAuditoriaObservacaoView from '@/views/list/ListAuditoriaObservacaoView.vue'
import ListCargaView from '@/views/list/ListCargaView.vue'
import ListCargaTransfolhaView from '@/views/list/ListCargaTransfolhaView.vue'
import ListSistemaView from '@/views/list/ListSistemaView.vue'
import ListEmailDestinatarioView from '@/views/list/ListEmailDestinatarioView.vue'
import ListFaturamentoView from '@/views/list/ListFaturamentoView.vue'
import ListResponseRoboCnpjView from '@/views/list/ListResponseRoboCnpjView.vue'
import ListCargaKarcherView from '@/views/list/ListCargaKarcherView.vue'
import ListCargaDestinatarioView from '@/views/list/ListCargaDestinatarioView.vue'
import ListMotoristaTransbordoView from '@/views/list/ListMotoristaTransbordoView.vue'
import ListBannerView from '@/views/list/ListBannerView.vue'
import ListCargaResponsavelView from '@/views/list/ListCargaResponsavelView.vue'
import ListResponsavelHistoricoSmsView from '@/views/list/ListResponsavelHistoricoSmsView.vue'
import ListMotoristaView from '@/views/list/ListMotoristaView.vue'
import ListCargaTempView from '@/views/list/ListCargaTempView.vue'
import ListAdminConfigView from '@/views/list/ListAdminConfigView.vue'
import ListRotaSlaView from '@/views/list/ListRotaSlaView.vue'
import ListFormatoArquivoRelatorioView from '@/views/list/ListFormatoArquivoRelatorioView.vue'
import ListMotoristaCancelamentoCargaView from '@/views/list/ListMotoristaCancelamentoCargaView.vue'
import ListAuditoriaView from '@/views/list/ListAuditoriaView.vue'
import ListOcorrenciaTrackingResponsavelView from '@/views/list/ListOcorrenciaTrackingResponsavelView.vue'
import ListEsconderMotoristaView from '@/views/list/ListEsconderMotoristaView.vue'
import ListRelatorioGeracaoView from '@/views/list/ListRelatorioGeracaoView.vue'
import ListCompartilhamentoAppView from '@/views/list/ListCompartilhamentoAppView.vue'
import ListResponsavelView from '@/views/list/ListResponsavelView.vue'
import ListErroIntegracaoView from '@/views/list/ListErroIntegracaoView.vue'
import ListAlertaView from '@/views/list/ListAlertaView.vue'
import ListRastreamentoView from '@/views/list/ListRastreamentoView.vue'
import ListMotoristaResponsavelView from '@/views/list/ListMotoristaResponsavelView.vue'
import ListBaseFretebasEmpresaView from '@/views/list/ListBaseFretebasEmpresaView.vue'
import ListResponsavelGrupoEconomicoView from '@/views/list/ListResponsavelGrupoEconomicoView.vue'
import ListRastreamentoHistoricoView from '@/views/list/ListRastreamentoHistoricoView.vue'
import ListTypeSmsView from '@/views/list/ListTypeSmsView.vue'
import ListAuditoriaMotivoView from '@/views/list/ListAuditoriaMotivoView.vue'
import ListPosicaoMotoristaView from '@/views/list/ListPosicaoMotoristaView.vue'
import ListCentroDeCustoView from '@/views/list/ListCentroDeCustoView.vue'
import ListMotoristaMensagemPushView from '@/views/list/ListMotoristaMensagemPushView.vue'
import ListMascaraTransportadorSacPublicoView from '@/views/list/ListMascaraTransportadorSacPublicoView.vue'
import ListTipoOcorrenciaView from '@/views/list/ListTipoOcorrenciaView.vue'
import ListResponseRoboView from '@/views/list/ListResponseRoboView.vue'
import ListPontaSlaView from '@/views/list/ListPontaSlaView.vue'
import ListReponsavelAssociadoView from '@/views/list/ListReponsavelAssociadoView.vue'
import ListResponsavelFilialView from '@/views/list/ListResponsavelFilialView.vue'
import ListResponsavelSaraivaView from '@/views/list/ListResponsavelSaraivaView.vue'
import ListParametroRelatorioView from '@/views/list/ListParametroRelatorioView.vue'
import ListStatusSmsView from '@/views/list/ListStatusSmsView.vue'
import ListBaseFretebasView from '@/views/list/ListBaseFretebasView.vue'
import ListSaraivaCnpjDisponivelView from '@/views/list/ListSaraivaCnpjDisponivelView.vue'
import ListEnderecoView from '@/views/list/ListEnderecoView.vue'
import ListCargaOpenlogView from '@/views/list/ListCargaOpenlogView.vue'
import PersistAlertaCargaView from '@/views/persist/PersistAlertaCargaView.vue'
import PersistPromocaoView from '@/views/persist/PersistPromocaoView.vue'
import PersistResponsavelWebhookView from '@/views/persist/PersistResponsavelWebhookView.vue'
import PersistConfigAlertaView from '@/views/persist/PersistConfigAlertaView.vue'
import PersistCargaMedlogView from '@/views/persist/PersistCargaMedlogView.vue'
import PersistWebserviceIntegracaoView from '@/views/persist/PersistWebserviceIntegracaoView.vue'
import PersistTypeWebhookView from '@/views/persist/PersistTypeWebhookView.vue'
import PersistStatusCargaView from '@/views/persist/PersistStatusCargaView.vue'
import PersistResponsavelVisualizadorView from '@/views/persist/PersistResponsavelVisualizadorView.vue'
import PersistCargaPesquisaSatisfacaoView from '@/views/persist/PersistCargaPesquisaSatisfacaoView.vue'
import PersistAuditoriaTransfolhaView from '@/views/persist/PersistAuditoriaTransfolhaView.vue'
import PersistCargaSaraivaView from '@/views/persist/PersistCargaSaraivaView.vue'
import PersistTipoRelatorioView from '@/views/persist/PersistTipoRelatorioView.vue'
import PersistAdministradorView from '@/views/persist/PersistAdministradorView.vue'
import PersistOcorrenciaTrackingView from '@/views/persist/PersistOcorrenciaTrackingView.vue'
import PersistResponsavelAssociadoView from '@/views/persist/PersistResponsavelAssociadoView.vue'
import PersistTipoPessoaRecebedorView from '@/views/persist/PersistTipoPessoaRecebedorView.vue'
import PersistRequestSswView from '@/views/persist/PersistRequestSswView.vue'
import PersistResponsavelConfigSmsView from '@/views/persist/PersistResponsavelConfigSmsView.vue'
import PersistCargaAryztaView from '@/views/persist/PersistCargaAryztaView.vue'
import PersistTokenPushView from '@/views/persist/PersistTokenPushView.vue'
import PersistCargaCorreiosView from '@/views/persist/PersistCargaCorreiosView.vue'
import PersistCargaFotoView from '@/views/persist/PersistCargaFotoView.vue'
import PersistAuditoriaObservacaoView from '@/views/persist/PersistAuditoriaObservacaoView.vue'
import PersistCargaView from '@/views/persist/PersistCargaView.vue'
import PersistCargaTransfolhaView from '@/views/persist/PersistCargaTransfolhaView.vue'
import PersistSistemaView from '@/views/persist/PersistSistemaView.vue'
import PersistEmailDestinatarioView from '@/views/persist/PersistEmailDestinatarioView.vue'
import PersistFaturamentoConfiguracaoView from '@/views/persist/PersistFaturamentoConfiguracaoView.vue'
import PersistResponseRoboCnpjView from '@/views/persist/PersistResponseRoboCnpjView.vue'
import PersistCargaKarcherView from '@/views/persist/PersistCargaKarcherView.vue'
import PersistCargaDestinatarioView from '@/views/persist/PersistCargaDestinatarioView.vue'
import PersistMotoristaTransbordoView from '@/views/persist/PersistMotoristaTransbordoView.vue'
import PersistBannerView from '@/views/persist/PersistBannerView.vue'
import PersistCargaResponsavelView from '@/views/persist/PersistCargaResponsavelView.vue'
import PersistResponsavelHistoricoSmsView from '@/views/persist/PersistResponsavelHistoricoSmsView.vue'
import PersistMotoristaView from '@/views/persist/PersistMotoristaView.vue'
import PersistCargaTempView from '@/views/persist/PersistCargaTempView.vue'
import PersistAdminConfigView from '@/views/persist/PersistAdminConfigView.vue'
import PersistRotaSlaView from '@/views/persist/PersistRotaSlaView.vue'
import PersistFormatoArquivoRelatorioView from '@/views/persist/PersistFormatoArquivoRelatorioView.vue'
import PersistMotoristaCancelamentoCargaView from '@/views/persist/PersistMotoristaCancelamentoCargaView.vue'
import PersistAuditoriaView from '@/views/persist/PersistAuditoriaView.vue'
import PersistOcorrenciaTrackingResponsavelView from '@/views/persist/PersistOcorrenciaTrackingResponsavelView.vue'
import PersistEsconderMotoristaView from '@/views/persist/PersistEsconderMotoristaView.vue'
import PersistRelatorioGeracaoView from '@/views/persist/PersistRelatorioGeracaoView.vue'
import PersistCompartilhamentoAppView from '@/views/persist/PersistCompartilhamentoAppView.vue'
import PersistResponsavelView from '@/views/persist/PersistResponsavelView.vue'
import PersistAlertaView from '@/views/persist/PersistAlertaView.vue'
import PersistRastreamentoView from '@/views/persist/PersistRastreamentoView.vue'
import PersistMotoristaResponsavelView from '@/views/persist/PersistMotoristaResponsavelView.vue'
import PersistBaseFretebasEmpresaView from '@/views/persist/PersistBaseFretebasEmpresaView.vue'
import PersistResponsavelGrupoEconomicoView from '@/views/persist/PersistResponsavelGrupoEconomicoView.vue'
import PersistRastreamentoHistoricoView from '@/views/persist/PersistRastreamentoHistoricoView.vue'
import PersistTypeSmsView from '@/views/persist/PersistTypeSmsView.vue'
import PersistAuditoriaMotivoView from '@/views/persist/PersistAuditoriaMotivoView.vue'
import PersistPosicaoMotoristaView from '@/views/persist/PersistPosicaoMotoristaView.vue'
import PersistCentroDeCustoView from '@/views/persist/PersistCentroDeCustoView.vue'
import PersistMotoristaMensagemPushView from '@/views/persist/PersistMotoristaMensagemPushView.vue'
import PersistMascaraTransportadorSacPublicoView from '@/views/persist/PersistMascaraTransportadorSacPublicoView.vue'
import PersistTipoOcorrenciaView from '@/views/persist/PersistTipoOcorrenciaView.vue'
import PersistResponseRoboView from '@/views/persist/PersistResponseRoboView.vue'
import PersistPontaSlaView from '@/views/persist/PersistPontaSlaView.vue'
import PersistReponsavelAssociadoView from '@/views/persist/PersistReponsavelAssociadoView.vue'
import PersistResponsavelFilialView from '@/views/persist/PersistResponsavelFilialView.vue'
import PersistResponsavelSaraivaView from '@/views/persist/PersistResponsavelSaraivaView.vue'
import PersistParametroRelatorioView from '@/views/persist/PersistParametroRelatorioView.vue'
import PersistStatusSmsView from '@/views/persist/PersistStatusSmsView.vue'
import PersistBaseFretebasView from '@/views/persist/PersistBaseFretebasView.vue'
import PersistSaraivaCnpjDisponivelView from '@/views/persist/PersistSaraivaCnpjDisponivelView.vue'
import PersistEnderecoView from '@/views/persist/PersistEnderecoView.vue'
import PersistCargaOpenlogView from '@/views/persist/PersistCargaOpenlogView.vue'
import ListResponsavelConfigWhatsappView from '@/views/list/ListResponsavelConfigWhatsappView.vue'
import DashboardLayoutView from '@/views/DashboardLayoutView.vue'
import PersistRelatorioAutomaticoView from '@/views/persist/PersistRelatorioAutomaticoView.vue'
import PersistNotasInseridasConfiguracaoView from '@/views/persist/PersistNotasInseridasConfiguracaoView.vue'
import ListNotasInseridasMonthlyView from '@/views/list/ListNotasInseridasMonthlyView.vue'
import ListNotasInseridasWeeklyView from '@/views/list/ListNotasInseridasWeeklyView.vue'
import PersistResponsavelGrupoParceiroView from '@/views/persist/PersistResponsavelGrupoParceiroView.vue'
import ListPanelUserView from '@/views/list/ListPanelUserView.vue'
import PersistPanelUserView from '@/views/persist/PersistPanelUserView.vue'
import PersistAdminConfigInternationalView from '@/views/persist/PersistAdminConfigInternationalView.vue'
import ListVisualizationModeView from '@/views/list/ListVisualizationModeView.vue'
import PersistVisualizationModeView from '@/views/persist/PersistVisualizationModeView.vue'
import ListExteriorCargoView from '@/views/list/ListExteriorCargoView.vue'
import ListReprocessamentoWebhookView from '@/views/list/ListReprocessamentoWebhookView.vue'
import ListResponsavelUsuarioView from '@/views/list/ListResponsavelUsuarioView.vue'
import PersistResponsavelUsuarioView from '@/views/persist/PersistResponsavelUsuarioView.vue'

/**
 * VUE Router Configuration
 */
export const router: RouterOptions = {
  mode: 'hash',

  routes: [
    {
      path: '/sign-in',
      name: 'signIn',
      component: SignInView,
    },
    {
      path: '/dashboard',
      component: DefaultLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: DashboardLayoutView,
          children: [
            {
              path: '/dashboard/monthly',
              name: 'dashboardMonthly',
              component: DashboardView,
              props: {annually: false},
            },
            {
              path: '/dashboard/annually',
              name: 'dashboardAnnually',
              component: DashboardView,
              props: {annually: true},
            },
          ],
        },

        {path: '/alerta-carga/list', component: ListAlertaCargaView},
        {path: '/alerta-carga/new', component: PersistAlertaCargaView},
        {
          path: '/alerta-carga/edit/:id',
          name: 'editAlertaCarga',
          component: PersistAlertaCargaView,
          props: true,
        },

        {path: '/promocao/list', component: ListPromocaoView},
        {path: '/promocao/new', component: PersistPromocaoView},
        {
          path: '/promocao/edit/:id',
          name: 'editPromocao',
          component: PersistPromocaoView,
          props: true,
        },

        {
          path: '/responsavel-webhook/list',
          component: ListResponsavelWebhookView,
        },
        {
          path: '/responsavel-webhook/new',
          component: PersistResponsavelWebhookView,
        },
        {
          path: '/responsavel-webhook/edit/:id',
          name: 'editResponsavelWebhook',
          component: PersistResponsavelWebhookView,
          props: true,
        },

        {path: '/config-alerta/list', component: ListConfigAlertaView},
        {path: '/config-alerta/new', component: PersistConfigAlertaView},
        {
          path: '/config-alerta/edit/:id',
          name: 'editConfigAlerta',
          component: PersistConfigAlertaView,
          props: true,
        },

        {path: '/carga-medlog/list', component: ListCargaMedlogView},
        {path: '/carga-medlog/new', component: PersistCargaMedlogView},
        {
          path: '/carga-medlog/edit/:id',
          name: 'editCargaMedlog',
          component: PersistCargaMedlogView,
          props: true,
        },

        {
          path: '/webservice-integracao/list',
          component: ListWebserviceIntegracaoView,
        },
        {
          path: '/webservice-integracao/new',
          component: PersistWebserviceIntegracaoView,
        },
        {
          path: '/webservice-integracao/edit/:id',
          name: 'editWebserviceIntegracao',
          component: PersistWebserviceIntegracaoView,
          props: true,
        },

        {path: '/type-webhook/list', component: ListTypeWebhookView},
        {path: '/type-webhook/new', component: PersistTypeWebhookView},
        {
          path: '/type-webhook/edit/:id',
          name: 'editTypeWebhook',
          component: PersistTypeWebhookView,
          props: true,
        },

        {path: '/status-carga/list', component: ListStatusCargaView},
        {path: '/status-carga/new', component: PersistStatusCargaView},
        {
          path: '/status-carga/edit/:id',
          name: 'editStatusCarga',
          component: PersistStatusCargaView,
          props: true,
        },

        {
          path: '/responsavel-visualizador/list',
          component: ListResponsavelVisualizadorView,
        },
        {
          path: '/responsavel-visualizador/new',
          component: PersistResponsavelVisualizadorView,
        },
        {
          path: '/responsavel-visualizador/edit/:id',
          name: 'editResponsavelVisualizador',
          component: PersistResponsavelVisualizadorView,
          props: true,
        },

        {
          path: '/carga-pesquisa-satisfacao/list',
          component: ListCargaPesquisaSatisfacaoView,
        },
        {
          path: '/carga-pesquisa-satisfacao/new',
          component: PersistCargaPesquisaSatisfacaoView,
        },
        {
          path: '/carga-pesquisa-satisfacao/edit/:id',
          name: 'editCargaPesquisaSatisfacao',
          component: PersistCargaPesquisaSatisfacaoView,
          props: true,
        },

        {
          path: '/auditoria-transfolha/list',
          component: ListAuditoriaTransfolhaView,
        },
        {
          path: '/auditoria-transfolha/new',
          component: PersistAuditoriaTransfolhaView,
        },
        {
          path: '/auditoria-transfolha/edit/:id',
          name: 'editAuditoriaTransfolha',
          component: PersistAuditoriaTransfolhaView,
          props: true,
        },

        {path: '/carga-saraiva/list', component: ListCargaSaraivaView},
        {path: '/carga-saraiva/new', component: PersistCargaSaraivaView},
        {
          path: '/carga-saraiva/edit/:id',
          name: 'editCargaSaraiva',
          component: PersistCargaSaraivaView,
          props: true,
        },

        {path: '/tipo-relatorio/list', component: ListTipoRelatorioView},
        {path: '/tipo-relatorio/new', component: PersistTipoRelatorioView},
        {
          path: '/tipo-relatorio/edit/:id',
          name: 'editTipoRelatorio',
          component: PersistTipoRelatorioView,
          props: true,
        },

        {path: '/administrador/list', component: ListAdministradorView},
        {path: '/administrador/new', component: PersistAdministradorView},
        {
          path: '/administrador/edit/:id',
          name: 'editAdministrador',
          component: PersistAdministradorView,
          props: true,
        },

        {
          path: '/ocorrencia-tracking/list',
          component: ListOcorrenciaTrackingView,
        },
        {
          path: '/ocorrencia-tracking/new',
          component: PersistOcorrenciaTrackingView,
        },
        {
          path: '/ocorrencia-tracking/edit/:id',
          name: 'editOcorrenciaTracking',
          component: PersistOcorrenciaTrackingView,
          props: true,
        },

        {
          path: '/responsavel-associado/list',
          component: ListResponsavelAssociadoView,
        },
        {
          path: '/responsavel-associado/new',
          component: PersistResponsavelAssociadoView,
        },
        {
          path: '/responsavel-associado/edit/:id',
          name: 'editResponsavelAssociado',
          component: PersistResponsavelAssociadoView,
          props: true,
        },

        {
          path: '/tipo-pessoa-recebedor/list',
          component: ListTipoPessoaRecebedorView,
        },
        {
          path: '/tipo-pessoa-recebedor/new',
          component: PersistTipoPessoaRecebedorView,
        },
        {
          path: '/tipo-pessoa-recebedor/edit/:id',
          name: 'editTipoPessoaRecebedor',
          component: PersistTipoPessoaRecebedorView,
          props: true,
        },

        {path: '/request-ssw/list', component: ListRequestSswView},
        {path: '/request-ssw/new', component: PersistRequestSswView},
        {
          path: '/request-ssw/edit/:id',
          name: 'editRequestSsw',
          component: PersistRequestSswView,
          props: true,
        },

        {
          path: '/responsavel-config-sms/list',
          component: ListResponsavelConfigSmsView,
        },
        {
          path: '/responsavel-config-sms/new',
          component: PersistResponsavelConfigSmsView,
        },
        {
          path: '/responsavel-config-sms/edit/:id',
          name: 'editResponsavelConfigSms',
          component: PersistResponsavelConfigSmsView,
          props: true,
        },

        {
          path: '/responsavel-config-whatsapp/list',
          component: ListResponsavelConfigWhatsappView,
        },

        {path: '/carga-aryzta/list', component: ListCargaAryztaView},
        {path: '/carga-aryzta/new', component: PersistCargaAryztaView},
        {
          path: '/carga-aryzta/edit/:id',
          name: 'editCargaAryzta',
          component: PersistCargaAryztaView,
          props: true,
        },

        {path: '/token-push/list', component: ListTokenPushView},
        {path: '/token-push/new', component: PersistTokenPushView},
        {
          path: '/token-push/edit/:id',
          name: 'editTokenPush',
          component: PersistTokenPushView,
          props: true,
        },

        {path: '/carga-correios/list', component: ListCargaCorreiosView},
        {path: '/carga-correios/new', component: PersistCargaCorreiosView},
        {
          path: '/carga-correios/edit/:id',
          name: 'editCargaCorreios',
          component: PersistCargaCorreiosView,
          props: true,
        },

        {path: '/carga-foto/list', component: ListCargaFotoView},
        {path: '/carga-foto/new', component: PersistCargaFotoView},
        {
          path: '/carga-foto/edit/:id',
          name: 'editCargaFoto',
          component: PersistCargaFotoView,
          props: true,
        },

        {
          path: '/auditoria-observacao/list',
          component: ListAuditoriaObservacaoView,
        },
        {
          path: '/auditoria-observacao/new',
          component: PersistAuditoriaObservacaoView,
        },
        {
          path: '/auditoria-observacao/edit/:id',
          name: 'editAuditoriaObservacao',
          component: PersistAuditoriaObservacaoView,
          props: true,
        },

        {path: '/carga/list', component: ListCargaView},
        {path: '/carga/new', component: PersistCargaView},
        {
          path: '/carga/edit/:id',
          name: 'editCarga',
          component: PersistCargaView,
          props: true,
        },

        {path: '/carga-transfolha/list', component: ListCargaTransfolhaView},
        {path: '/carga-transfolha/new', component: PersistCargaTransfolhaView},
        {
          path: '/carga-transfolha/edit/:id',
          name: 'editCargaTransfolha',
          component: PersistCargaTransfolhaView,
          props: true,
        },

        {path: '/sistema/list', component: ListSistemaView},
        {path: '/sistema/new', component: PersistSistemaView},
        {
          path: '/sistema/edit/:id',
          name: 'editSistema',
          component: PersistSistemaView,
          props: true,
        },

        {
          path: '/email-destinatario/list',
          component: ListEmailDestinatarioView,
        },
        {
          path: '/email-destinatario/new',
          component: PersistEmailDestinatarioView,
        },
        {
          path: '/email-destinatario/edit/:id',
          name: 'editEmailDestinatario',
          component: PersistEmailDestinatarioView,
          props: true,
        },

        {path: '/faturamento/list', component: ListFaturamentoView},
        {
          path: '/faturamento/config',
          component: PersistFaturamentoConfiguracaoView,
        },

        {path: '/response-robo-cnpj/list', component: ListResponseRoboCnpjView},
        {
          path: '/response-robo-cnpj/new',
          component: PersistResponseRoboCnpjView,
        },
        {
          path: '/response-robo-cnpj/edit/:id',
          name: 'editResponseRoboCnpj',
          component: PersistResponseRoboCnpjView,
          props: true,
        },

        {path: '/carga-karcher/list', component: ListCargaKarcherView},
        {path: '/carga-karcher/new', component: PersistCargaKarcherView},
        {
          path: '/carga-karcher/edit/:id',
          name: 'editCargaKarcher',
          component: PersistCargaKarcherView,
          props: true,
        },

        {
          path: '/carga-destinatario/list',
          component: ListCargaDestinatarioView,
        },
        {
          path: '/carga-destinatario/new',
          component: PersistCargaDestinatarioView,
        },
        {
          path: '/carga-destinatario/edit/:id',
          name: 'editCargaDestinatario',
          component: PersistCargaDestinatarioView,
          props: true,
        },

        {
          path: '/motorista-transbordo/list',
          component: ListMotoristaTransbordoView,
        },
        {
          path: '/motorista-transbordo/new',
          component: PersistMotoristaTransbordoView,
        },
        {
          path: '/motorista-transbordo/edit/:id',
          name: 'editMotoristaTransbordo',
          component: PersistMotoristaTransbordoView,
          props: true,
        },

        {path: '/banner/list', component: ListBannerView},
        {path: '/banner/new', component: PersistBannerView},
        {
          path: '/banner/edit/:id',
          name: 'editBanner',
          component: PersistBannerView,
          props: true,
        },

        {path: '/carga-responsavel/list', component: ListCargaResponsavelView},
        {
          path: '/carga-responsavel/new',
          component: PersistCargaResponsavelView,
        },
        {
          path: '/carga-responsavel/edit/:id1/:id2',
          name: 'editCargaResponsavel',
          component: PersistCargaResponsavelView,
          props: true,
        },

        {
          path: '/responsavel-historico-sms/list',
          component: ListResponsavelHistoricoSmsView,
        },
        {
          path: '/responsavel-historico-sms/new',
          component: PersistResponsavelHistoricoSmsView,
        },
        {
          path: '/responsavel-historico-sms/edit/:id',
          name: 'editResponsavelHistoricoSms',
          component: PersistResponsavelHistoricoSmsView,
          props: true,
        },

        {path: '/motorista/list', component: ListMotoristaView},
        {path: '/motorista/new', component: PersistMotoristaView},
        {
          path: '/motorista/edit/:id',
          name: 'editMotorista',
          component: PersistMotoristaView,
          props: true,
        },

        {path: '/carga-temp/list', component: ListCargaTempView},
        {path: '/carga-temp/new', component: PersistCargaTempView},
        {
          path: '/carga-temp/edit/:id',
          name: 'editCargaTemp',
          component: PersistCargaTempView,
          props: true,
        },

        {path: '/admin-config/list', component: ListAdminConfigView},
        {path: '/admin-config/new', component: PersistAdminConfigView},
        {
          path: '/admin-config/edit/:id',
          name: 'editAdminConfig',
          component: PersistAdminConfigView,
          props: true,
        },
        {
          path: '/internacional/admin-config/edit/:id',
          name: 'editInternacionalAdminConfig',
          component: PersistAdminConfigInternationalView,
          props: true,
        },

        {path: '/rota-sla/list', component: ListRotaSlaView},
        {path: '/rota-sla/new', component: PersistRotaSlaView},
        {
          path: '/rota-sla/edit/:id1/:id2/:id3',
          name: 'editRotaSla',
          component: PersistRotaSlaView,
          props: true,
        },

        {
          path: '/formato-arquivo-relatorio/list',
          component: ListFormatoArquivoRelatorioView,
        },
        {
          path: '/formato-arquivo-relatorio/new',
          component: PersistFormatoArquivoRelatorioView,
        },
        {
          path: '/formato-arquivo-relatorio/edit/:id',
          name: 'editFormatoArquivoRelatorio',
          component: PersistFormatoArquivoRelatorioView,
          props: true,
        },

        {
          path: '/motorista-cancelamento-carga/list',
          component: ListMotoristaCancelamentoCargaView,
        },
        {
          path: '/motorista-cancelamento-carga/new',
          component: PersistMotoristaCancelamentoCargaView,
        },
        {
          path: '/motorista-cancelamento-carga/edit/:id',
          name: 'editMotoristaCancelamentoCarga',
          component: PersistMotoristaCancelamentoCargaView,
          props: true,
        },

        {path: '/auditoria/list', component: ListAuditoriaView},
        {path: '/auditoria/new', component: PersistAuditoriaView},
        {
          path: '/auditoria/edit/:id',
          name: 'editAuditoria',
          component: PersistAuditoriaView,
          props: true,
        },

        {
          path: '/ocorrencia-tracking-responsavel/list',
          component: ListOcorrenciaTrackingResponsavelView,
        },
        {
          path: '/ocorrencia-tracking-responsavel/new',
          component: PersistOcorrenciaTrackingResponsavelView,
        },
        {
          path: '/ocorrencia-tracking-responsavel/edit/:id',
          name: 'editOcorrenciaTrackingResponsavel',
          component: PersistOcorrenciaTrackingResponsavelView,
          props: true,
        },

        {
          path: '/esconder-motorista/list',
          component: ListEsconderMotoristaView,
        },
        {
          path: '/esconder-motorista/new',
          component: PersistEsconderMotoristaView,
        },
        {
          path: '/esconder-motorista/edit/:id',
          name: 'editEsconderMotorista',
          component: PersistEsconderMotoristaView,
          props: true,
        },

        {path: '/relatorio-geracao/list', component: ListRelatorioGeracaoView},
        {
          path: '/relatorio-geracao/new',
          component: PersistRelatorioGeracaoView,
        },
        {
          path: '/relatorio-geracao/edit/:id',
          name: 'editRelatorioGeracao',
          component: PersistRelatorioGeracaoView,
          props: true,
        },

        {
          path: '/compartilhamento-app/list',
          component: ListCompartilhamentoAppView,
        },
        {
          path: '/compartilhamento-app/new',
          component: PersistCompartilhamentoAppView,
        },
        {
          path: '/compartilhamento-app/edit/:id',
          name: 'editCompartilhamentoApp',
          component: PersistCompartilhamentoAppView,
          props: true,
        },

        {path: '/responsavel/list', component: ListResponsavelView},
        {path: '/responsavel/new', component: PersistResponsavelView},
        {
          path: '/responsavel/edit/:id',
          name: 'editResponsavel',
          component: PersistResponsavelView,
          props: true,
        },
        {
          path: '/responsavel-usuario/list/:id',
          name: 'listResponsavelUsuario',
          props: true,
          component: ListResponsavelUsuarioView,
        },
        {
          path: '/responsavel-usuario/:id1/edit/:id2',
          name: 'editResponsavelUsuario',
          props: true,
          component: PersistResponsavelUsuarioView,
        },
        {
          path: '/responsavel-usuario/:id1/new',
          name: 'editResponsavelUsuario',
          props: true,
          component: PersistResponsavelUsuarioView,
        },

        {path: '/erro-integracao/list', component: ListErroIntegracaoView},

        {path: '/alerta/list', component: ListAlertaView},
        {path: '/alerta/new', component: PersistAlertaView},
        {
          path: '/alerta/edit/:id',
          name: 'editAlerta',
          component: PersistAlertaView,
          props: true,
        },

        {path: '/rastreamento/list', component: ListRastreamentoView},
        {path: '/rastreamento/new', component: PersistRastreamentoView},
        {
          path: '/rastreamento/edit/:id',
          name: 'editRastreamento',
          component: PersistRastreamentoView,
          props: true,
        },

        {
          path: '/motorista-responsavel/list',
          component: ListMotoristaResponsavelView,
        },
        {
          path: '/motorista-responsavel/new',
          component: PersistMotoristaResponsavelView,
        },
        {
          path: '/motorista-responsavel/edit/:id1/:id2',
          name: 'editMotoristaResponsavel',
          component: PersistMotoristaResponsavelView,
          props: true,
        },

        {
          path: '/base-fretebas-empresa/list',
          component: ListBaseFretebasEmpresaView,
        },
        {
          path: '/base-fretebas-empresa/new',
          component: PersistBaseFretebasEmpresaView,
        },
        {
          path: '/base-fretebas-empresa/edit/:id',
          name: 'editBaseFretebasEmpresa',
          component: PersistBaseFretebasEmpresaView,
          props: true,
        },

        {
          path: '/responsavel-grupo-economico/list',
          component: ListResponsavelGrupoEconomicoView,
        },
        {
          path: '/responsavel-grupo-economico/new',
          component: PersistResponsavelGrupoEconomicoView,
        },
        {
          path: '/responsavel-grupo-economico/edit/:id',
          name: 'editResponsavelGrupoEconomico',
          component: PersistResponsavelGrupoEconomicoView,
          props: true,
        },

        {
          path: '/responsavel-grupo-parceiro/edit/:id',
          name: 'editResponsavelGrupoParceiro',
          component: PersistResponsavelGrupoParceiroView,
          props: true,
        },
        {
          path: '/rastreamento-historico/list',
          component: ListRastreamentoHistoricoView,
        },
        {
          path: '/rastreamento-historico/new',
          component: PersistRastreamentoHistoricoView,
        },
        {
          path: '/rastreamento-historico/edit/:id',
          name: 'editRastreamentoHistorico',
          component: PersistRastreamentoHistoricoView,
          props: true,
        },

        {path: '/type-sms/list', component: ListTypeSmsView},
        {path: '/type-sms/new', component: PersistTypeSmsView},
        {
          path: '/type-sms/edit/:id',
          name: 'editTypeSms',
          component: PersistTypeSmsView,
          props: true,
        },

        {path: '/auditoria-motivo/list', component: ListAuditoriaMotivoView},
        {path: '/auditoria-motivo/new', component: PersistAuditoriaMotivoView},
        {
          path: '/auditoria-motivo/edit/:id',
          name: 'editAuditoriaMotivo',
          component: PersistAuditoriaMotivoView,
          props: true,
        },

        {path: '/posicao-motorista/list', component: ListPosicaoMotoristaView},
        {
          path: '/posicao-motorista/new',
          component: PersistPosicaoMotoristaView,
        },
        {
          path: '/posicao-motorista/edit/:id',
          name: 'editPosicaoMotorista',
          component: PersistPosicaoMotoristaView,
          props: true,
        },

        {path: '/centro-de-custo/list', component: ListCentroDeCustoView},
        {path: '/centro-de-custo/new', component: PersistCentroDeCustoView},
        {
          path: '/centro-de-custo/edit/:id1/:id2',
          name: 'editCentroDeCusto',
          component: PersistCentroDeCustoView,
          props: true,
        },

        {
          path: '/motorista-mensagem-push/list',
          component: ListMotoristaMensagemPushView,
        },
        {
          path: '/motorista-mensagem-push/new',
          component: PersistMotoristaMensagemPushView,
        },
        {
          path: '/motorista-mensagem-push/edit/:id',
          name: 'editMotoristaMensagemPush',
          component: PersistMotoristaMensagemPushView,
          props: true,
        },

        {
          path: '/mascara-transportador-sac-publico/list',
          component: ListMascaraTransportadorSacPublicoView,
        },
        {
          path: '/mascara-transportador-sac-publico/new',
          component: PersistMascaraTransportadorSacPublicoView,
        },
        {
          path: '/mascara-transportador-sac-publico/edit/:id',
          name: 'editMascaraTransportadorSacPublico',
          component: PersistMascaraTransportadorSacPublicoView,
          props: true,
        },

        {path: '/tipo-ocorrencia/list', component: ListTipoOcorrenciaView},
        {path: '/tipo-ocorrencia/new', component: PersistTipoOcorrenciaView},
        {
          path: '/tipo-ocorrencia/edit/:id',
          name: 'editTipoOcorrencia',
          component: PersistTipoOcorrenciaView,
          props: true,
        },

        {path: '/response-robo/list', component: ListResponseRoboView},
        {path: '/response-robo/new', component: PersistResponseRoboView},
        {
          path: '/response-robo/edit/:id',
          name: 'editResponseRobo',
          component: PersistResponseRoboView,
          props: true,
        },

        {path: '/ponta-sla/list', component: ListPontaSlaView},
        {path: '/ponta-sla/new', component: PersistPontaSlaView},
        {
          path: '/ponta-sla/edit/:id',
          name: 'editPontaSla',
          component: PersistPontaSlaView,
          props: true,
        },

        {
          path: '/reponsavel-associado/list',
          component: ListReponsavelAssociadoView,
        },
        {
          path: '/reponsavel-associado/new',
          component: PersistReponsavelAssociadoView,
        },
        {
          path: '/reponsavel-associado/edit/:id',
          name: 'editReponsavelAssociado',
          component: PersistReponsavelAssociadoView,
          props: true,
        },

        {
          path: '/responsavel-filial/list',
          component: ListResponsavelFilialView,
        },
        {
          path: '/responsavel-filial/new',
          component: PersistResponsavelFilialView,
        },
        {
          path: '/responsavel-filial/edit/:id',
          name: 'editResponsavelFilial',
          component: PersistResponsavelFilialView,
          props: true,
        },

        {
          path: '/responsavel-saraiva/list',
          component: ListResponsavelSaraivaView,
        },
        {
          path: '/responsavel-saraiva/new',
          component: PersistResponsavelSaraivaView,
        },
        {
          path: '/responsavel-saraiva/edit/:id',
          name: 'editResponsavelSaraiva',
          component: PersistResponsavelSaraivaView,
          props: true,
        },

        {
          path: '/parametro-relatorio/list',
          component: ListParametroRelatorioView,
        },
        {
          path: '/parametro-relatorio/new',
          component: PersistParametroRelatorioView,
        },
        {
          path: '/parametro-relatorio/edit/:id',
          name: 'editParametroRelatorio',
          component: PersistParametroRelatorioView,
          props: true,
        },

        {path: '/status-sms/list', component: ListStatusSmsView},
        {path: '/status-sms/new', component: PersistStatusSmsView},
        {
          path: '/status-sms/edit/:id',
          name: 'editStatusSms',
          component: PersistStatusSmsView,
          props: true,
        },

        {path: '/base-fretebas/list', component: ListBaseFretebasView},
        {path: '/base-fretebas/new', component: PersistBaseFretebasView},
        {
          path: '/base-fretebas/edit/:id',
          name: 'editBaseFretebas',
          component: PersistBaseFretebasView,
          props: true,
        },

        {
          path: '/saraiva-cnpj-disponivel/list',
          component: ListSaraivaCnpjDisponivelView,
        },
        {
          path: '/saraiva-cnpj-disponivel/new',
          component: PersistSaraivaCnpjDisponivelView,
        },
        {
          path: '/saraiva-cnpj-disponivel/edit/:id',
          name: 'editSaraivaCnpjDisponivel',
          component: PersistSaraivaCnpjDisponivelView,
          props: true,
        },

        {path: '/endereco/list', component: ListEnderecoView},
        {path: '/endereco/new', component: PersistEnderecoView},
        {
          path: '/endereco/edit/:id',
          name: 'editEndereco',
          component: PersistEnderecoView,
          props: true,
        },

        {path: '/carga-openlog/list', component: ListCargaOpenlogView},
        {path: '/carga-openlog/new', component: PersistCargaOpenlogView},
        {
          path: '/carga-openlog/edit/:id',
          name: 'editCargaOpenlog',
          component: PersistCargaOpenlogView,
          props: true,
        },
        {
          path: '/relatorio-automatico/edit',
          name: 'editRelatorioAutomatico',
          component: PersistRelatorioAutomaticoView,
        },
        {
          path: '/acompanhamento-notas-inseridas/config',
          name: 'acompanhamentoNotasInseridasConfig',
          component: PersistNotasInseridasConfiguracaoView,
        },
        {
          path: '/acompanhamento-notas-inseridas/mensal',
          name: 'acompanhamentoNotasInseridasMensal',
          component: ListNotasInseridasMonthlyView,
        },
        {
          path: '/acompanhamento-notas-inseridas/semanal',
          name: 'acompanhamentoNotasInseridasSemanal',
          component: ListNotasInseridasWeeklyView,
        },
        {
          path: '/reprocessamento-webhook',
          component: ListReprocessamentoWebhookView,
        },
        // Internacional
        {
          path: '/internacional/responsavel/list',
          component: ListPanelUserView,
          name: 'listInternationalResponsavel',
        },
        {
          path: '/internacional/responsavel/new',
          component: PersistPanelUserView,
        },
        {
          path: '/internacional/responsavel/edit/:id',
          name: 'editResponsavelInternacional',
          component: PersistPanelUserView,
          props: true,
        },
        {
          path: '/internacional/grupo-visualizador/list',
          name: 'listInternationalVisualizationMode',
          component: ListVisualizationModeView,
        },
        {
          path: '/internacional/grupo-visualizador/new',
          component: PersistVisualizationModeView,
        },
        {
          path: '/internacional/grupo-visualizador/edit/:id',
          name: 'editInternacionalVisualizationMode',
          component: PersistVisualizationModeView,
          props: true,
        },
        {path: '/internacional/cargo/list', component: ListExteriorCargoView},
      ],
    },
    {path: '/', redirect: '/sign-in'},
    {path: '*', redirect: '/dashboard'},
  ],
}
